export default __webpack_public_path__ + "static/media/excel.e062b25b.svg";